<template>
  <container
    :style="sideNavStyle"
    :breakpoint="breakpoint"
  >
    <nav-close-btn
      @click="$emit('sideNavigationToggle')"
      :breakpoint="breakpoint"
    >
      <span>
        <font-awesome-icon :icon="['fa', 'arrow-left']" />
      </span>
      <span>{{ $t("VMX.mobile_nav_close") }}</span>
    </nav-close-btn>
    <item-div
      class="vmx-header__nav-item-container"
      v-for="(item, index) in items"
      :key="index"
      :breakpoint="breakpoint"
      v-bind="navItemProps(item)"
      :hidden="'showMenuItem' in item ? !item.showMenuItem : false"
      :active="navItemProps(item).active ? 'rgba(255, 255, 255, 0.3)' : null"
      :ref="`menu-item-${index}`"
      :only-in-mobile="item.onlyInMobile ? breakpoint : 99999"
    >
      <template v-if="item.subMenu">
        <dropdown-menu
          v-if="isApp === true ? !(('onlyInVMX' in item) && item.onlyInVMX) : true && displayHeaderContent(item)"
          :items="item.subMenu"
          :width="width"
          :item-nr="index"
          @subActive="setActive"
        >
          <span>
            <icon-wrapper :breakpoint="breakpoint">
              <template v-if="item.icon">
                <font-awesome-icon :icon="icon(item.icon)" />
              </template>
            </icon-wrapper>
            {{ item.name }}
          </span>
        </dropdown-menu>
      </template>
      <template v-else>
        <component
          v-if="isApp === true ? !(('onlyInVMX' in item) && item.onlyInVMX) : true && displayHeaderContent(item)"
          :is="tag(item, isApp)"
          v-bind="tagProps(item)"
          @click.native="additionalClick()"
          class="_nav-item"
          @click="action(tagProps(item))"
        >
          <icon-wrapper :breakpoint="breakpoint">
            <template v-if="item.icon">
              <font-awesome-icon :icon="icon(item.icon)" />
            </template>
          </icon-wrapper>
          {{ item.name }}
        </component>
      </template>
    </item-div>
    <template v-if="width <= this.breakpoint">
      <separator />
      <slot />
    </template>
  </container>
</template>

<script>
import styled from '@u-rogel/vue-emotion'
import tagMixins from '~/mixins/tagMixins'
import headerMixins from '~/mixins/headerMixins'
import DropdownMenu from './DropdownMenu.vue'

const Container = styled.div`
  height: 40px;
  @media (min-width: ${({ breakpoint }) => breakpoint + 1 || 1025}px) {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
    padding-left: 2rem;
    padding-right: 2rem;
    margin: auto;
  }


  @media (max-width: ${({ breakpoint }) => breakpoint || 1024}px) {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 998;
   top: 0;
    left: 0;
    overflow-x: hidden;
    padding-top: 25px;
    transition: 0.5s;
    background-color: var(--header-navbar-bg);
  }
`({
  breakpoint: Number,
})

const ItemDiv = styled.div`
  .router-link-exact-active.active {
    background-color: rgba(255, 255, 255, 0.3)
  }
  &:hover a {
   text-decoration: none;
  }
  background-color: ${({ active }) => active};
  //&.sub-active {
  //  background-color: rgba(255, 255, 255, 0.2)
  //}
  @media (min-width: ${({ breakpoint }) => breakpoint + 1 || 1025}px) {
    height: 100%;
    display: flex;
    align-items: center;
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    > div {
      position: relative;
    }
  }

  > :nth-child(1) {
    color: var(--header-navbar-bg-contrast);
    padding: 0 25px;
    white-space: nowrap;
    @media (max-width: 1366px) {
      padding: 10px 15px;
      display: block;
    }
    @media (max-width: ${({ breakpoint }) => breakpoint || 1024}px) {
      padding: 10px 0;
      display: block;
      &:hover {
        text-decoration: none;
      }
    }
  }

  @media (max-width: ${({ breakpoint }) => breakpoint || 1024}px) {
    padding: 0 18px 0 20px;
    text-decoration: none;
    transition: 0.3s;
  }
  @media (min-width: ${({ onlyInMobile }) => onlyInMobile + 1}px) {
    display: none;
  }
`({
  breakpoint: Number,
  active: String,
  onlyInMobile: Number,
})

const IconWrapper = styled.span`
  @media (min-width: ${({ breakpoint }) => breakpoint || 1024}px) {
    display: none;
  }
  display: inline-block;
  width: 21px;
  color: var(--header-navbar-bg-contrast);
  svg {
    margin-right: 5px;
  }

`({
  breakpoint: Number,
})

const NavCloseBtn = styled.div`
  display: none;
  > :nth-child(1) {
    padding: 10px 10px 10px 15px;
  }
  span {
    color: var(--header-navbar-bg-contrast);
    font-weight: bold;
    cursor: pointer;
  }
  @media (max-width: ${({ breakpoint }) => breakpoint || 1024}px) {
    padding: 0 8px 8px 0;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
`({
  breakpoint: Number,
})

const Separator = styled.div`
  border-bottom: 1px solid var(--header-navbar-bg-contrast);
  opacity: .5;
  margin: 15px;
`()

export default {
  name: 'BannerMenu',
  inject: {
    TrackingUtil: {
      type: Function,
    },
  },
  mixins: [
    tagMixins,
    headerMixins,
  ],
  components: {
    Container,
    ItemDiv,
    NavCloseBtn,
    DropdownMenu,
    IconWrapper,
    Separator,
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
    width: {
      type: Number,
      default: 0,
    },
    sideNavigationOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isApp() {
      return localStorage.getItem('isApp') === 'true'
    },
    sideNavStyle() {
      if (this.width > this.breakpoint) {
        return null
      }
      return this.sideNavigationOpen ? 'width: 85%' : 'width: 0'
    },
  },
  methods: {
    action(url) {
       if (url.dataType === 'link' && this.isApp) {
        window.openLink(url.href)
      } 
    },
    displayHeaderContent(params) {
      if ('display' in params) {
        return params.display[localStorage.getItem('content')]
      }
      return true
    },
    icon(icon) {
      // eslint-disable-next-line prefer-const
      let [first, ...rest] = icon.split('-')
      rest = rest.join('-')
      if (first && rest) {
        return [first, rest]
      }
      return ['fa', 'question']
    },
    additionalClick() {
      localStorage.removeItem('wentBack')
      const pages = ['PosterPage', 'IndustrySymposiaPage', 'PresentationSearchPage', 'FacultySearchPage', 'PagSearchPage', 'AbstractSearchPage']
      localStorage.setItem('disableBack', true)
      if (pages.includes(this.$route.name)) {
        this.$root.$refs.pagPage.pagContainerReload()
      }
    },
    navItemProps(item) {
      return {
        active: this.isActive(item),
      }
    },
    setActive(nr) {
      const element = this.$refs[`menu-item-${nr}`]
      if (element) {
        // element[0].classList.add('sub-active')
      }
    },
  },
  watch: {
    $route() {
      if (this.sideNavigationOpen) this.$emit('sideNavigationToggle')
    },
  },
}
</script>
